import React from 'react'

const CancellationAndRefundPolicy = () => {
  return (
    <div className="max-w-4xl mx-auto px-6 py-12 text-gray-700">
      <h1 className="text-xl md:2xl font-bold text-black mb-6">Cancellation & Refund Policy
      </h1>
      <ul className="text-gray-600 md:text-md mt-2 ml-3 text-sm list-decimal">
        <li>
          The participant may cancel their retreat booking by sending the cancellation request in writing over email to
          <a href="mailto:mitra@param.life" className="text-primary hover:underline"> mitra@param.life</a>. For the purpose of refund, we will consider only written cancellation requests sent via email. The date of receiving the cancellation request will be considered as the date of the cancellation.
        </li>
        <li>
          For retreat bookings cancelled more than 45 days prior to the start date of the program date, 5% deduction will be done towards the processing fee, and 95% of the money will be refunded.
        </li>
        <li>
          For retreat bookings cancelled within 44 days to 30 days prior to the start date of the program date, 75% of the money will be refunded.
        </li>
        <li>
          For retreat bookings cancelled within 29 days to 15 days prior to the start date of the program date, 25% of the money will be refunded.
        </li>
        <li>
          For retreat bookings cancelled within 14 days to 8 days prior to the start date of the program date, only 10% of the amount will be refundable.
        </li>
        <li>
          For retreat bookings cancelled within 7 days or lesser prior to the start date of the program date, no amount will be refundable.
        </li>
        <li>
          The cancellation charge will not be transferrable or adjustable towards the payment of another program. Upon the request of the participant, only the refundable amount as mentioned above can be considered as a partial payment for another program.
        </li>
        <li>
          Before initiating the refund, the PARAM team will communicate the refund amount as per policy to the participant through the registered email ID. Upon receiving the bank account details from the participant, the refund amount will be transferred to the same bank account.
        </li>
        <li>
          In case of cancellation due to an Extremely Unavoidable Reason, the participant's reservation will be cancelled when we receive the cancellation request, however, refunds will not be issued until adequate supporting documentation has been received, such as a doctor's certification, court notification, or death certificate.
        </li>
        <li>
          For any cancellation due to reasons other than an Extremely Unavoidable Reason, the refund will be initiated within 15 days of the cancellation date.
        </li>
        <li>
          PARAM will not be responsible for any delay in refund processing caused by unresponsiveness or delay from the participant in providing the required details and confirmation.
        </li>
      </ul>
    </div>
  )
}

export default CancellationAndRefundPolicy;
